import axios from 'axios';
import { API_URL } from './api';

export const agreementService = {
    list () {
        console.log('agreementService: list');

        return axios
            .get(`${API_URL}/overeenkomsten`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    update (id, formData) {
        console.log('agreementService: update');

        return axios
            .put(`${API_URL}/overeenkomsten/${id}`, formData)
            .then((response) => response);
    },

    get (id) {
        console.log('agreementService: get', id);

        return axios
            .get(`${API_URL}/overeenkomsten/${id}`)
            .then((response) => {
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    pdf (id) {
        console.log('agreementService: pdf', id);

        return axios
            .get(`${API_URL}/overeenkomsten/pdf/${id}`, {
                responseType: 'arraybuffer',
            })
            .then((response) => response);
    },
};

export default agreementService;
